import { render, staticRenderFns } from "./ReplyNewParentalResponsibilities.vue?vue&type=template&id=58b4040b"
import script from "./ReplyNewParentalResponsibilities.vue?vue&type=script&lang=ts"
export * from "./ReplyNewParentalResponsibilities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports